import React from 'react';
import { getBaseUrl } from '../services/api';

interface Props {
  src?: string | null;
  alt?: string;
  className?: string;
}

/**
 * Simple image preview that opens the image in a new tab.
 * If src is a relative path (starts with '/'), it prefixes with API base.
 */
const ImagePreview: React.FC<Props> = ({ src, alt, className }) => {
  if (!src) return null;
  const baseUrl = getBaseUrl();
  const url = src.startsWith('http') ? src : `${baseUrl}${src}`;
  return (
    <a href={url} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
      <img src={url} alt={alt || ''} className={className || 'w-16 h-16 object-cover rounded'} />
    </a>
  );
};

export default ImagePreview;
